import { render, staticRenderFns } from "./DynamicFormFieldTestimonials.vue?vue&type=template&id=0b8c8bd2&"
import script from "./DynamicFormFieldTestimonials.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFieldTestimonials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports